import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';

import { MerchandiseBackgroundComponentStore } from './merchandise-background.component-store';

@Component({
  selector: 'epc-merchandise-background',
  templateUrl: './merchandise-background.component.html',
  styleUrls: ['./merchandise-background.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MerchandiseBackgroundComponentStore],
  standalone: false,
})
export class MerchandiseBackgroundComponent {
  public IMAGE_MAX_SIZES = IMAGE_MAX_SIZES;

  public backgroundUrl$ = this.componentStore.backgroundUrl$;

  constructor(private componentStore: MerchandiseBackgroundComponentStore) {}
}
